"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hoarder = void 0;
const Phase_1 = require("../../Phase");
const IAward_1 = require("../IAward");
class Hoarder {
    constructor() {
        this.name = 'Hoarder';
        this.description = 'Have the most cards in hand';
    }
    getScore(player) {
        if (player.game.phase === Phase_1.Phase.RESEARCH)
            return 0;
        let score = player.cardsInHand.length;
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Hoarder = Hoarder;
//# sourceMappingURL=Hoarder.js.map